@if (kasiteltava?.liitteet?.length > 0) {
  <div style="padding: 15px 20px">
    <div class="light-blue-text" style="font-size: 1rem; margin-top: 0; margin-bottom: 8px">Laskulla on {{ kasiteltava.liitteet.length }} liitetiedostoa. Näet liitteet varsinaisen laskun jälkeen.</div>
    <div style="height: 2px; background-color: #f0f0f0"></div>
  </div>
}
<div #esikatseluContainer style="text-align: left; width: 100%; overflow: visible; position: relative">
  @if (!(lataaminenValmisObservable | async) && naytaLatausmerkinta) {
    <div lemon-loading [show]="true"></div>
  }
  <div [style.height]="spacerHeightStyleObservable | async" style="width: 100%"></div>
  <div [style.visibility]="(lataaminenValmisObservable | async) ? 'visible' : 'hidden'" [style.left]="laskuLeftCoordinate + 'px'" style="width: 595px; transform-origin: 0 0; position: absolute; top: 0px" [style.transform]="transformStyleObservable | async">
    <div class="kokopdflasku" #kokopdflasku style="position: relative; width: 100%; line-height: initial">
      @if (ulkoinenLasku) {
        <div style="color: grey; padding: 10px">{{ 'pdf-perinteinen.ulkoinen-lasku' | translatel: kieli }}{{ ulkoinenLasku.nimi }}</div>
      }

      <div #ylaosa>
        <table style="width: 100%">
          <tr>
            <td [class.logocontainer]="asetukset?.base64Logo" style="width: 54.761904761904724%">
              @if (asetukset?.base64Logo) {
                <div style="font-weight: 300; font-size: 10px">
                  <img id="logo" [src]="'data:image/jpg;base64,' + asetukset?.base64Logo" /><br />
                  @if (!asetukset?.piilotaYrityksenNimiLaskulla) {
                    <span>{{ asetukset?.nimi }}</span>
                  }
                </div>
              }
              @if (!asetukset?.base64Logo) {
                <div class="otsikko" style="font-weight: 600; font-size: 16px">
                  {{ asetukset?.nimi }}
                </div>
              }
            </td>
            <td class="rightMargin" rowspan="2">
              <div style="font-weight: 800; font-size: 12px; margin-top: 30px; padding-bottom: 5px">{{ otsikko }}</div>
              <div class="viiva"></div>
              <table id="laskutiedot" style="padding-top: 9px">
                <tr>
                  <td>{{ 'pdf-perinteinen.laskunnro' | translatel: kieli }}</td>
                  <td>{{ laskunumero }}</td>
                </tr>
                @if (!mitatoity) {
                  <tr>
                    <td>{{ 'pdf-perinteinen.viitenro' | translatel: kieli }}</td>
                    <td>{{ viitenumero }}</td>
                  </tr>
                }
                <tr>
                  <td>{{ 'pdf-perinteinen.laskunpvm' | translatel: kieli }}</td>
                  <td>{{ pvm }}</td>
                </tr>
                <tr>
                  <td>{{ 'pdf-perinteinen.toimituspvm' | translatel: kieli }}</td>
                  <td>{{ toimituspvm }}</td>
                </tr>
                @if (!mitatoity) {
                  <tr>
                    <td>{{ 'pdf-perinteinen.erapaiva' | translatel: kieli }}</td>
                    <td style="font-weight: 800">{{ erapaiva }}</td>
                  </tr>
                }
                @if (!muistutus && !mitatoity) {
                  <tr>
                    <td>{{ 'pdf-perinteinen.maksuehto' | translatel: kieli }}</td>
                    <td>{{ maksuaikaa }} {{ 'pdf-perinteinen.pvnetto' | translatel: kieli }}</td>
                  </tr>
                }
                @if (!mitatoity) {
                  <tr>
                    <td>{{ 'pdf-perinteinen.viivastyskorko' | translatel: kieli }}</td>
                    <td>{{ viivastysprosentti }}</td>
                  </tr>
                }
              </table>
              @if (kasiteltava?.viitteenne) {
                <div style="margin-top: 5px; font-size: 12px">
                  <span style="font-weight: 800">{{ ('lasku.esikatselu.viitteenne' | translatel: kieli) + ': ' }}</span> {{ kasiteltava?.viitteenne }}
                </div>
              }

              @if (muistutushuomautus) {
                <div style="margin-top: 5px; font-size: 12px; font-weight: 800">
                  {{ muistutushuomautus }}
                </div>
              }
            </td>
          </tr>
          <tr>
            <td class="leftMargin">
              <div style="font-weight: 600; font-size: 13px; line-height: 16px; padding-top: 25px">
                {{ kasiteltava?.asiakas?.nimi }}<br />
                @if (kasiteltava?.asiakas?.ytunnus) {
                  {{ kasiteltava?.asiakas?.ytunnus }}<br />
                }
                {{ kasiteltava?.asiakas?.katuosoite }}<br />
                {{ kasiteltava?.asiakas?.postinro }} {{ kasiteltava?.asiakas?.postitmp }}<br />
                {{ maa }}
              </div>
            </td>
          </tr>
        </table>
        <div style="height: 20px"></div>
        <div class="kokosivunviiva"></div>
        <div style="height: 10px"></div>
        @if (lisatiedot) {
          <div class="leftMargin rightMargin" style="padding-top: 10px; font-size: 12px; padding-bottom: 20px" [innerHtml]="lisatiedot"></div>
        }
      </div>

      <!-- [style.min-height]="tuotteetMinimumHeightStyleObservable | async" -->
      <div style="min-height: 150px">
        <table id="tuotteet" class="leftMargin rightMargin">
          <thead>
            <tr>
              <th class="nimi">{{ 'pdf-perinteinen.tuote' | translatel: kieli }}</th>
              @if (this.onkoProjekti) {
                <td class="projekti">{{ 'pdf-perinteinen.projekti' | translatel: kieli }}</td>
              }
              <th class="maara">{{ 'pdf-perinteinen.maara' | translatel: kieli }}</th>
              <th class="hinta">{{ 'pdf-perinteinen.yksikkohinta' | translatel: kieli }}</th>
              <th class="alv">{{ 'pdf-perinteinen.alv' | translatel: kieli }}</th>
              <th class="ale">{{ 'pdf-perinteinen.ale' | translatel: kieli }}</th>
              <th class="yhteensa">{{ 'pdf-perinteinen.yhteensa-ilman-alv' | translatel: kieli }}</th>
              <th class="yhteensa">{{ 'pdf-perinteinen.yhteensa' | translatel: kieli }}</th>
            </tr>
          </thead>
          <tbody>
            @for (tuote of kasiteltava?.tuotteet; track tuote) {
              <tr>
                <td class="nimi">{{ tuote?.tuote?.nimi }}</td>
                @if (this.onkoProjekti) {
                  <td class="projekti">{{ tuote?.projekti?.nimi }}</td>
                }
                <td class="maara">{{ tuote?.maara | ldecimall: 4 : kieli }}</td>
                <td class="hinta">{{ tuote?.hinta | lmoneyl: kasiteltava?.valuutta : kieli }}</td>
                <td class="alv">{{ tuote?.alv?.prosentti | ldecimall: 2 : kieli }} %</td>
                <td class="ale">{{ tuote?.ale | ldecimall: 4 : kieli }}{{ tuote?.ale ? ' %' : '' }}</td>
                <td class="yhteensa">{{ shared.annaLaskurivinYhteensaIlmanAlvLaskunTuotteelle(tuote) | lmoneyl: kasiteltava?.valuutta : kieli }}</td>
                <td class="yhteensa">{{ shared.annaLaskurivinYhteensaLaskunTuotteelle(tuote) | lmoneyl: kasiteltava?.valuutta : kieli }}</td>
              </tr>
            }
          </tbody>
          <tfoot style="text-align: right">
            <tr>
              <td colspan="5">{{ 'pdf-perinteinen.ilman-alv' | translatel: kieli }}</td>
              <td colspan="2">{{ laskunSummat?.yhteensaIlmanAlv | lbigmoneyl: kasiteltava?.valuutta : kieli }}</td>
            </tr>
            @for (erittelynOsa of alvErittely; track erittelynOsa) {
              <tr class="alverittely">
                <td colspan="5">{{ (erittelynOsa.alvKanta.prosentti | ldecimall: 2 : kieli) + '%' }} {{ 'pdf-perinteinen.yhteensa-pienella' | translatel: kieli }}</td>
                <td colspan="2">{{ erittelynOsa.alvinSumma | lbigmoneyl: kasiteltava?.valuutta : kieli }}</td>
              </tr>
            }
            @if (alvErittely.length !== 1) {
              <tr>
                <td colspan="5">{{ 'pdf-perinteinen.alv-yhteensa' | translatel: kieli }}</td>
                <td colspan="2">{{ laskunSummat?.yhteensaAlv | lbigmoneyl: kasiteltava?.valuutta : kieli }}</td>
              </tr>
            }
            @if (muistutus && maksettuAiemmin && !maksettuAiemmin.eq('0')) {
              <tr>
                <td colspan="5">{{ 'pdf-perinteinen.yhteensa-ennen-aiemmin-maksettua' | translatel: kieli }}</td>
                <td colspan="2">{{ laskunSummat?.yhteensaKaikki | lbigmoneyl: kasiteltava?.valuutta : kieli }}</td>
              </tr>
            }
            @if (muistutus && maksettuAiemmin && !maksettuAiemmin.eq('0')) {
              <tr>
                <td colspan="5">{{ 'pdf-perinteinen.maksettu-aiemmin' | translatel: kieli }}</td>
                <td colspan="2">{{ maksettuAiemmin | lbigmoneyl: kasiteltava?.valuutta : kieli }}</td>
              </tr>
            }
            <tr>
              <td colspan="5">{{ 'pdf-perinteinen.maksettava-yhteensa' | translatel: kieli }}</td>
              <td colspan="2">{{ maksettavaaYhteensa | lbigmoneyl: kasiteltava?.valuutta : kieli }}</td>
            </tr>
            <tr>
              <td colspan="7">&nbsp;</td>
            </tr>
            @if (laskunKonvertoidutSummat && kasiteltava?.valuuttakonversio) {
              <tr>
                <td colspan="5">(Vain kirjanpidossa näkyvä tieto) Maksettavaa yhteensä valuuttamuunnoksen jälkeen</td>
                <td colspan="2">{{ laskunKonvertoidutSummat.yhteensaKaikki | lbigmoneyl: kasiteltava.valuuttakonversio.kohdevaluutta : kieli }}</td>
              </tr>
            }
            @if (laskunKonvertoidutSummat && kasiteltava?.valuuttakonversio) {
              <tr>
                <td colspan="5">Kurssi {{ shared.formatoiPvm(kasiteltava.valuuttakonversio.hakupaiva, null, kasiteltava) }}: 1 {{ kasiteltava.valuuttakonversio.lahdevaluutta }} = {{ kasiteltava.valuuttakonversio.kurssi.rate | ldecimall: 4 : kieli }} {{ kasiteltava.valuuttakonversio.kohdevaluutta }}</td>
                <td colspan="2"></td>
              </tr>
            }
          </tfoot>
        </table>
      </div>

      <div #alaosa>
        @if (alvHuomautus) {
          <div class="leftMargin rightMargin" style="padding-top: 3em; padding-bottom: 0.5em; font-size: 11px">
            {{ alvHuomautus }}
          </div>
        }
        @if (asetukset?.ohjeet) {
          <div class="leftMargin rightMargin" style="font-size: 9px; line-height: 11px; padding-top: 2.5em">
            {{ asetukset?.ohjeet }}
          </div>
        }

        <div style="height: 2em"></div>

        <table style="width: 100%">
          <tr style="font-size: 8px; font-weight: 600">
            <td class="leftMarginWidth"></td>
            <td class="pienenTiedonLeveysEnnenLaatikkoa">{{ 'pdf-perinteinen.yritys' | translatel: kieli }}</td>
            <td class="pienenTiedonLeveysEnnenLaatikkoa">{{ 'pdf-perinteinen.postiosoite' | translatel: kieli }}</td>
            <td class="pienenTiedonLeveysEnnenLaatikkoa">{{ 'pdf-perinteinen.yhteystiedot' | translatel: kieli }}</td>
          </tr>
          <tr style="font-size: 8px; font-weight: 300">
            <td></td>
            <td>{{ asetukset?.nimi }}</td>
            <td>{{ asetukset?.katuosoite }}</td>
            <td>{{ asetukset?.puhelin }}</td>
          </tr>
          <tr style="font-size: 8px; font-weight: 300">
            <td></td>
            <td>{{ asetukset?.ytunnus }}</td>
            <td>{{ asetukset?.postinro }} {{ asetukset?.postitmp }}, {{ laskuttajanMaa }}</td>
            <td>{{ asetukset?.replyto }}</td>
          </tr>
        </table>

        <div id="pdfpreviewaalaosa" style="width: 100%; padding-top: 7px; padding-top: 5px; border-top: 1px dashed lightgrey; position: relative">
          <table id="pdfpreviewaalaosaloppu">
            <tr style="height: 48px">
              <td class="e" style="font-size: 8px; font-weight: 600"><br />{{ 'pdf-perinteinen.saajan-tilinro' | translatel: kieli }}</td>
              <td class="o t" style="font-size: 8px; font-weight: 600">
                IBAN<br />
                @if (!mitatoity) {
                  {{ asetukset?.pankki }} {{ iban }}
                }
              </td>
              <td class="" style="font-size: 8px; font-weight: 600" colspan="4" rowspan="3">
                BIC<br />
                @if (!mitatoity) {
                  {{ asetukset?.bic }}
                }
                <!-- <div style="position: absolute; top: 5px; right: 5px; width: 16.6667%" lemon-qrcode [qrcodeValue]="qrkoodi" *ngIf="qrkoodi && !mitatoity"></div> -->
              </td>
            </tr>
            <tr style="height: 42px">
              <td class="y e" style="font-size: 8px; font-weight: 600">{{ 'pdf-perinteinen.saaja' | translatel: kieli }}</td>
              <td class="y o t" style="font-size: 11px; font-weight: 300">
                @if (!mitatoity) {
                  {{ asetukset?.nimi }}
                }
              </td>
            </tr>
            <tr>
              <td class="e" rowspan="1" class="y" style="height: 96px; font-size: 8px; font-weight: 600; border-right: 1px solid transparent">
                {{ 'pdf-perinteinen.nimi-osoite' | translatel: kieli }}
              </td>
              <td rowspan="1" class="y o" style="height: 96px; font-size: 11px; font-weight: 300">
                @if (!mitatoity) {
                  {{ kasiteltava?.asiakas?.nimi }}<br />
                  {{ kasiteltava?.asiakas?.katuosoite }}<br />
                  {{ kasiteltava?.asiakas?.postinro }} {{ kasiteltava?.asiakas?.postitmp }}<br />
                  {{ maa }}
                }
              </td>
            </tr>
            <tr>
              <td class="e" style="height: 24px; font-size: 8px; font-weight: 600; border-right: 1px solid transparent">{{ 'pdf-perinteinen.allekirjoitus' | translatel: kieli }}</td>
              <td class="o t">
                <div style="width: 100%; height: 100%; border-bottom: 1px solid rgba(0, 0, 0, 0.5)">&nbsp;</div>
              </td>
              <td class="y" style="font-size: 8px; font-weight: 800">{{ 'pdf-perinteinen.viitenro' | translatel: kieli }}</td>
              <td class="y" style="font-size: 11px; font-weight: 300" colspan="3">
                @if (!mitatoity) {
                  {{ viitenumero }}
                }
              </td>
            </tr>
            <tr style="height: 24px">
              <td class="y a e" style="font-size: 8px; font-weight: 600">{{ 'pdf-perinteinen.tililta' | translatel: kieli }}</td>
              <td class="y a o t"></td>
              <td class="y a o" style="font-size: 8px; font-weight: 800">{{ 'pdf-perinteinen.erapaiva' | translatel: kieli }}</td>
              <td class="y a o" style="font-size: 11px; font-weight: 300; width: 12.5%">{{ erapaiva }}</td>
              <td class="y a" style="font-size: 8px; font-weight: 800">{{ lokalisoituValuutta }}</td>
              <td class="y a" width="*" style="font-size: 11px; font-weight: 300; text-align: right">
                @if (!mitatoity) {
                  {{ maksettavaaYhteensa | lbigmoneyl: kasiteltava?.valuutta : kieli }}
                }
              </td>
            </tr>
            <tr>
              <td colspan="3" style="border-right: transparent; text-align: center"></td>
              <td colspan="3" style="font-size: 6px; line-height: 7px; font-weight: 300; width: auto; padding-right: 2em; padding-bottom: 1.5em; padding-top: 1.5em">
                {{ 'pdf-perinteinen.maksun-valitys-tiedote' | translatel: kieli }}
              </td>
            </tr>
          </table>
          <!-- <div lemon-barcode [barcodeValue]="virtuaaliviivakoodi" *ngIf="virtuaaliviivakoodi && !mitatoity" style="position: absolute; bottom: 2px; left: 20px;"></div> -->
        </div>
      </div>
    </div>
  </div>
</div>

@for (liiteJaData of liitteetObservable | async; track liiteJaData; let i = $index) {
  <div>
    <div style="height: 2px; background-color: #f0f0f0; margin-top: 5px"></div>
    <div style="margin-left: 10px; font-size: 20px; line-height: 40px">Liite {{ i + 1 }}: {{ liiteJaData.liite.nimi }}</div>
    @if (liiteJaData.type) {
      @if (liiteJaData.loading) {
        <div style="margin: 20px; text-align: center">
          Liitetiedostoa ladataan...
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      } @else {
        @if (liiteJaData.type === 'pdf') {
          <div app-pdf-viewer [url]="liiteJaData.data | async"></div>
        }
        @if (liiteJaData.type === 'jpg' || liiteJaData.type === 'png') {
          <div app-image-zoom [thumbImage]="liiteJaData.data | async"></div>
        }
      }
    } @else {
      <div>
        <app-primary-button (click)="lataaLiitetiedosto(liiteJaData.liite)" actionId="Tallenna laskun liite omalle koneelle" [actionContext]="[liiteJaData.liite.avain]"> Tallenna liite omalle koneelle </app-primary-button>
      </div>
    }
  </div>
}
